import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/app";
import { fetchListNetworkProvider } from "../../../store/NetworkProviderSlice";
import ToolBar from "../../../components/ToolBar";
import SearchNetworkProvider from "./components/SearchNetworkProvider";
import AddNetworkProvider from "./components/AddNetworkProvider";
import { Tabs } from "antd";
import ListTable from "./components/ListTable";
import EditNetworkProvider from "./components/EditNetworkProvider";
import DeleteNetworkProvider from "./components/DeleteNetworkProvider";

const NetworkProvider: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [savePayload, setSavePayload] = useState<any>();
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [listHaveData, setListHaveData] = useState<boolean>(true);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [editModalData, seteditModalData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const getList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        pageNumber: data?.pageNumber ?? paginationData?.pageNumber,
        pageSize: data?.pageSize ?? paginationData?.pageSize,
      };
      setSavePayload(payload);
      dispatch(fetchListNetworkProvider(payload))
        .then((res: any) => {
          setListHaveData(false);
          setListData(res?.indexedResults);
          setTotalData(res?.totalRecords);
          setTableLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setTableLoading(false);
        });
    },
    [paginationData, dispatch]
  );
  useEffect(() => {
    if (listHaveData) {
      getList();
    }
  }, [getList, listHaveData]);
  const handleEditModal = (record: any) => {
    setOpenEditModal(!openEditModal);
    seteditModalData(record);
  };
  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };
  return (
    <>
      <ToolBar title={"Email Network Providers"} />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        onChange={getList}
        items={[
          {
            key: "1",
            label: "Add Email Network Providers",
            children: (
              <AddNetworkProvider getList={getList} totalData={totalData} />
            ),
          },
          {
            key: "2",
            label: "Search Email Network Providers",
            children: (
              <SearchNetworkProvider
                getList={getList}
                setPaginationData={setPaginationData}
              />
            ),
          },
        ]}
      />
      <ListTable
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={tableloading}
        setTableLoading={setTableLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        savePayload={savePayload}
        handleEditModal={handleEditModal}
        handleDeleteRequest={handleDeleteRequest}
      />
      <EditNetworkProvider
        handleEditModal={handleEditModal}
        editModalData={editModalData}
        getList={getList}
        openEditModal={openEditModal}
      />
      <DeleteNetworkProvider
        title={openDeleteData?.providers}
        close={handleDeleteRequest}
        open={openDeleteModal}
        deleteValues={openDeleteData}
        name={"Provider Code"}
        getList={getList}
      />
    </>
  );
};

export default NetworkProvider;
